import { TagButton } from './styles';

interface TagProps extends React.HTMLProps<HTMLButtonElement> {
  isDisabled?: boolean;
}

export const Tag: React.FC<TagProps> = ({ isDisabled = false, children }: TagProps) => {
  return <TagButton disabled={isDisabled}>{children}</TagButton>;
};
